import { useState } from "react";
import { useMutation } from "react-query";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { fetchGetTaskCounterDetail } from "../miscellaneous/fetchGetTaskCounterDetail";
import { fetchUpdateTaskCounterTemplate } from "../miscellaneous/fetchUpdateTaskCounterTemplate";
import { fetchGetTaskCounterJobTitles } from "../miscellaneous/fetchGetJobTitlesByOrg";
import { TaskCounterTemplateDetail } from "../types/TaskCounterTypes";

export const useUpdateTaskCounterTemplate = () => {
  const [taskDetail, setTaskDetail] = useState<TaskCounterTemplateDetail | null>(null);
  const [jobTitles, setJobTitles] = useState<any[]>([]);

  const navigate = useNavigate();

  const mutationGetDetail = useMutation(fetchGetTaskCounterDetail, {
    onSuccess: (res) => {
      if (res.status === 200) {
        setTaskDetail(res.data);
        if (res.data.organizationId) {
          mutationGetJobTitles.mutate(res.data.organizationId);
        }
      }
    },
    onError: () => {},
  });

  const mutationGetJobTitles = useMutation(fetchGetTaskCounterJobTitles, {
    onSuccess: (res) => {
      if (res.status === 200) {
        const jobs = _.map(res.data ?? [], (item: any) => {
          return { id: item.id, title: item.title };
        });
        setJobTitles(jobs);
      }
    },
    onError: () => {},
  });

  const mutationUpdateTemplate = useMutation(fetchUpdateTaskCounterTemplate, {
    onSuccess: (res) => {
      if (res.status === 200) {
        navigate(-1);
      }
    },
    onError: () => {},
  });

  return {
    taskDetail,
    setTaskDetail,
    jobTitles,
    mutationGetDetail,
    mutationUpdateTemplate,
    mutationGetJobTitles,
  };
};
